module.exports = __webpack_public_path__ + "static/media/yingyon_03.d4aa87c5.png";